/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineStreamingService
 */

export const AgentConfigChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.AgentConfigChirpContentBlock';
export const ContextChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ContextChirpContentBlock';
export const DisplayOnlyChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.DisplayOnlyChirpContentBlock';
export const FileChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.FileChirpContentBlock';
export const ImageChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ImageChirpContentBlock';
export const ImageToolResultChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ImageToolResultChirpContentBlock';
export const PdfChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.PdfChirpContentBlock';
export const PendingToolResultChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.PendingToolResultChirpContentBlock';
export const RedactedThinkingChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.RedactedThinkingChirpContentBlock';
export const ServerToolUseChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ServerToolUseChirpContentBlock';
export const TextChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.TextChirpContentBlock';
export const ThinkingChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ThinkingChirpContentBlock';
export const ToolApprovalRequestChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ToolApprovalRequestChirpContentBlock';
export const ToolResultChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ToolResultChirpContentBlock';
export const ToolUseChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ToolUseChirpContentBlock';
export const AviatorChirpDisplayOnlyDeltaTypename = 'com.hubspot.aviator.agent.stream.content.blocks.chirp.AviatorChirpDisplayOnlyDelta';
export const AviatorChirpImageDeltaTypename = 'com.hubspot.aviator.agent.stream.content.blocks.chirp.AviatorChirpImageDelta';
export const AviatorChirpInputJsonDeltaTypename = 'com.hubspot.aviator.agent.stream.content.blocks.chirp.AviatorChirpInputJsonDelta';
export const AviatorChirpTextDeltaTypename = 'com.hubspot.aviator.agent.stream.content.blocks.chirp.AviatorChirpTextDelta';
export const AviatorChirpThinkingDeltaTypename = 'com.hubspot.aviator.agent.stream.content.blocks.chirp.AviatorChirpThinkingDelta';
export const AviatorChirpCompactionEndTypename = 'com.hubspot.aviator.agent.stream.events.chirp.AviatorChirpCompactionEnd';
export const AviatorChirpCompactionStartTypename = 'com.hubspot.aviator.agent.stream.events.chirp.AviatorChirpCompactionStart';
export const AviatorChirpContentBlockDeltaEventTypename = 'com.hubspot.aviator.agent.stream.events.chirp.AviatorChirpContentBlockDeltaEvent';
export const AviatorChirpContentBlockStartTypename = 'com.hubspot.aviator.agent.stream.events.chirp.AviatorChirpContentBlockStart';
export const AviatorChirpContentBlockStopTypename = 'com.hubspot.aviator.agent.stream.events.chirp.AviatorChirpContentBlockStop';
export const AviatorChirpKeepaliveTypename = 'com.hubspot.aviator.agent.stream.events.chirp.AviatorChirpKeepalive';
export const AviatorChirpMessageEndTypename = 'com.hubspot.aviator.agent.stream.events.chirp.AviatorChirpMessageEnd';
export const AviatorChirpMessageStartTypename = 'com.hubspot.aviator.agent.stream.events.chirp.AviatorChirpMessageStart';
export const AviatorChirpToolResultEventTypename = 'com.hubspot.aviator.agent.stream.events.chirp.AviatorChirpToolResultEvent';
export const AppSearchScopeContextTypename = 'com.hubspot.breeze.engine.shared.models.context.AppSearchScopeContext';
export const BreezeAssistantTrackingContextTypename = 'com.hubspot.breeze.engine.shared.models.context.BreezeAssistantTrackingContext';
export const CrmObjectContextTypename = 'com.hubspot.breeze.engine.shared.models.context.CrmObjectContext';
export const DeviceContextTypename = 'com.hubspot.breeze.engine.shared.models.context.DeviceContext';
export const FileReferencesContextTypename = 'com.hubspot.breeze.engine.shared.models.context.FileReferencesContext';
export const InteractiveModeContextTypename = 'com.hubspot.breeze.engine.shared.models.context.InteractiveModeContext';
export const PageContextTypename = 'com.hubspot.breeze.engine.shared.models.context.PageContext';
export const SkillsContextTypename = 'com.hubspot.breeze.engine.shared.models.context.SkillsContext';
export const SubAgentExecutionContextTypename = 'com.hubspot.breeze.engine.shared.models.context.SubAgentExecutionContext';
export const SubagentConfigContextTypename = 'com.hubspot.breeze.engine.shared.models.context.SubagentConfigContext';
export const TimeZoneContextTypename = 'com.hubspot.breeze.engine.shared.models.context.TimeZoneContext';
export const ToolSetCustomizationsContextTypename = 'com.hubspot.breeze.engine.shared.models.context.ToolSetCustomizationsContext';
export const ViewedArtifactContextTypename = 'com.hubspot.breeze.engine.shared.models.context.ViewedArtifactContext';
export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const sendMessageRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineStreamingService',
  rpcName: 'sendMessage',
  auth: 'app',
  fingerprint: 'BQECbiSrTx_DntOSlRpHZVJ8GnIfkswz',
  na1Only: false,
  isStreaming: true,
  isHublessAppAuth: false
};
export const sendMessagesRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineStreamingService',
  rpcName: 'sendMessages',
  auth: 'app',
  fingerprint: 'pRUjLbu2LkvDntOSlRpHZVJ8GnIfkswz',
  na1Only: false,
  isStreaming: true,
  isHublessAppAuth: false
};
export const sendStructuredInputRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineStreamingService',
  rpcName: 'sendStructuredInput',
  auth: 'app',
  fingerprint: 'E10nMlRTE-XDntOSlRpHZVJ8GnIfkswz',
  na1Only: false,
  isStreaming: true,
  isHublessAppAuth: false
};
export const sendToolResponseRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineStreamingService',
  rpcName: 'sendToolResponse',
  auth: 'app',
  fingerprint: 's-GRCYqO5AvDntOSlRpHZVJ8GnIfkswz',
  na1Only: false,
  isStreaming: true,
  isHublessAppAuth: false
};
export const sendToolApprovalRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineStreamingService',
  rpcName: 'sendToolApproval',
  auth: 'app',
  fingerprint: 'wRWpOGHnQurDntOSlRpHZVJ8GnIfkswz',
  na1Only: false,
  isStreaming: true,
  isHublessAppAuth: false
};
export const cancelTurnRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineStreamingService',
  rpcName: 'cancelTurn',
  auth: 'app',
  fingerprint: 'cKX0x47vNVqOUe2e_r4XmVJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resumeStreamRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineStreamingService',
  rpcName: 'resumeStream',
  auth: 'app',
  fingerprint: 'NOGAxYyiTVrDntOSlRpHZVJ8GnIfkswz',
  na1Only: false,
  isStreaming: true,
  isHublessAppAuth: false
};
export const submitFeedbackRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineStreamingService',
  rpcName: 'submitFeedback',
  auth: 'app',
  fingerprint: 'jK3hNmvIzqeOUe2e_r4XmVJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};